import { useEffect, useState } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import SkeletonTableLoad from "../../components/SkeletonTableLoad";
import { DistanceBandSet } from "../../models/Admin/DistanceBands";
import msalRestClient from "../../services/clients/MsalRestClient";

const DistanceBandOverview = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [seletedVersion, setSelectedVersion] = useState<number>(0);
    const [distanceBands, setDistanceBands]    = useState<DistanceBandSet[]>([]);

    useEffect(() => {
        fetchDistanceBands();
    }, []);

    /**
     * Method fetches a collection of all saved DistanceBandSets.
     */
    async function fetchDistanceBands() {

        setIsLoading(true);

        /* Fetch data from backend service */
        msalRestClient.get<DistanceBandSet[]>("/api/distanceBands")
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched distanceBandSets to the current state */
                    setDistanceBands(response.data);
                }
                else if (response.status === 204) {
                    /* No distanceBandsSet could be found for the specified filter, set state to empty collection */
                    setDistanceBands([]);
                }
            })
            .catch(error => { })
            .finally(() => setIsLoading(false));

    }

    /**
     * Function handles deletion of single entries.
     * @param index Index of entry that needs to be deleted.
     */
    async function handleDelete(index?: number) {
        /* Check if index passed on */
        if (index && index > -1) {

            let entity = distanceBands.find(x => x.version === seletedVersion)?.values.at(index);
            if (entity) {
                /* Delete from Distance Band Set */
                msalRestClient.delete("/api/distanceBands/" + entity.id)
                    .then(response => {
                        if (response.status === 200) {
                            /* Set fetched Distance Bands Sets after the selected entry has been deleted ...*/
                            fetchDistanceBands();
                        }
                    })
                    .catch(error => {
                        // Proper error handling goes here ...
                    })
            }
        }
    }

    /* JSX Element for rendering in Browser */
    return (
        <main className="container">
            <div className="row">

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={2}>
                                                    <label>Version</label>
                                                    <select className="form-select mb-2" defaultValue={seletedVersion} onChange={e => setSelectedVersion(Number(e.target.value))}>
                                                        {
                                                            distanceBands.map((value, index) => {
                                                                return (
                                                                    <option value={value.version}>{value.version}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </th>
                                                <th colSpan={1}>
                                                    <button className="btn btn-success mb-2">
                                                        <i className="bi bi-plus"></i>
                                                    </button>
                                                </th>
                                                <th colSpan={2}></th>
                                            </tr>
                                            <tr>
                                                <th>#</th>
                                                <th>Min. Value</th>
                                                <th>Max. Value</th>
                                                <th>Amount</th>
                                                <th>
                                                    { /* Empty for controls */ }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                distanceBands.find(x => x.version === seletedVersion)?.values.sort(x => Number(x.minValue)).map((x, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{x.id}</td>
                                                            <td>{x.minValue} km</td>
                                                            <td>{x.maxValue} km</td>
                                                            <td>{x.amount} &euro;</td>
                                                            <td>
                                                                <DeleteDialog index={index} title={"Please confirm ..."} description="Do you really want to delete the record?" btnClass={"btn btn-danger"} btnIcon={"bi bi-trash"} key={"btnDelete" + index} onConfirm={handleDelete} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )

}
export default DistanceBandOverview;